"use client";

import { useEffect, useState } from "react";
import { MessagePayload, onMessage } from "firebase/messaging";
import { messaging } from "../firebase";
import useFCMToken from "./useFCMToken";
import { toast } from "react-toastify";

export default function useFCM() {
  const { fcmToken, requestPermission, showPrompt } = useFCMToken();
  const [messages, setMessages] = useState<MessagePayload[]>([]);

  useEffect(() => {
    if (!("serviceWorker" in navigator) || !("Notification" in window)) return;

    const msg = messaging();
    let unsub: (() => void) | undefined;

    const handler = (payload: MessagePayload) => {
      toast.dark(payload.notification?.title ?? "New Notification");
      setMessages((prev) => [...prev, payload]);
    };

    const subscribe = async () => {
      try {
        unsub = onMessage(msg, handler);
      } catch (e) {
        console.error("FCM onMessage subscription failed:", e);
      }
    };

    subscribe();

    return () => unsub?.();
  }, [fcmToken]);

  return { fcmToken, messages, requestPermission, showPrompt };
}